import {
  getInvoice,
  patchPayOnlineInvoice,
} from '../api/bernabeu';

import {
  invoiceSlice,
  callTypes
} from "../../redux/reducers/invoiceSlice";

const { actions } = invoiceSlice;

const fetchInvoice = (id) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.list }));

    getInvoice(id).then((response: any) => {
      resolve(response);

      dispatch(actions.invoiceFetched());
    }).catch((error) => {
      console.log('fetchCreditPurchases falhou:');
      console.log({error});
      dispatch(actions.invoiceFetched());

      reject(false);
    });
  });
}

const payOnlineInvoice = (id, paymentMethod, metadata = {}, clientCardId = null, autoRenew = false) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    let params: any = {
      payment_method: paymentMethod,
      metadata: metadata,
    };

    if (clientCardId) {
      params.client_card_id = clientCardId;
    }

    if (autoRenew) {
      params.auto_renew = autoRenew;
    }

    patchPayOnlineInvoice(id, params).then((response: any) => {
      resolve(response);
    }).catch((error) => {
      console.log('payOnlineInvoice falhou:');
      console.log({error});
      dispatch(actions.invoiceFetched());
      reject(false);
    });
  });
}

export {
  fetchInvoice,
  payOnlineInvoice,
}